<template>
  <div class="component-tag-box" :style="{height: domHieght/3.75 + 'vw'}">
    <div class="tag" :style="{color:txtColor,background:bgColor,border: '0.3vw solid' +  border,lineHeight: domHieght/3.75 + 'vw'}">
      <slot />
    </div>
  </div>
</template>
<script>
    export default {
        components: {},
        props: {
            txtColor: {
                type: String,
                default: ''
            },
            bgColor: {
                type: String,
                default: ''
            },
            border: {
                type: String,
                default: ''
            },
            domHieght: {
                type: Number,
                default: 32
            }
        },
        data () {
            return {

            }
        },
        computed: {

        },
        methods: {

        },
        mounted () {}
    }
</script>
<style scoped lang="less">
  @vv: 3.75vw;
  .component-tag-box{
    display: table;
    margin-right: 8/@vv;
    height: 32/@vv;
      .tag{
        padding:0/@vv 8/@vv;
        font-size:20/@vv;
        line-height: 32/@vv;
        font-family:PingFangSC-Regular,PingFang SC;
        -webkit-font-smoothing: antialiased;
        font-weight:400;
        border-radius:2/@vv;
        box-sizing: border-box;
        display: table-cell;
        vertical-align: middle;
      }
  }

</style>
